import { render, staticRenderFns } from "./TipoDispositivo.vue?vue&type=template&id=0e9b120f&"
import script from "./TipoDispositivo.vue?vue&type=script&lang=ts&"
export * from "./TipoDispositivo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0e9b120f', component.options)
    } else {
      api.reload('0e9b120f', component.options)
    }
    module.hot.accept("./TipoDispositivo.vue?vue&type=template&id=0e9b120f&", function () {
      api.rerender('0e9b120f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TipoDispositivo/TipoDispositivo.vue"
export default component.exports